import React from 'react';
import PropTypes from 'prop-types';
import { TitleComponent } from './TitleComponent';

function CompositeCalloutComponent({
  compositeParentClass = '',
  headerSize = [3, ''],
  headingText = '',
  // titleParentClass = 'title-class',
  childComponent,
}) {
  return (
    <div className={compositeParentClass}>
      {headingText ? (
        <TitleComponent headerSize={headerSize} headingText={headingText} />
      ) : (
        ''
      )}
      {childComponent}
    </div>
  );
}

CompositeCalloutComponent.propTypes = {
  compositeParentClass: PropTypes.string,
  headerSize: PropTypes.array,
  headingText: PropTypes.string,
  titleParentClass: PropTypes.string,
  childComponent: PropTypes.object,
};

export default CompositeCalloutComponent;
